import { Center, Container, Loader, Title } from '@mantine/core';
import { UserFolders } from '../../components/UserFolders';
import { useParams } from 'react-router';
import { useAppSelector } from '@store';

export const UserFilter = () => {
  const { filterId } = useParams();
  const filters = useAppSelector((state) => state.filters.filters);
  const isLoadingFilters = useAppSelector((state) => state.filters.isLoading);
  const isLoadingFolders = useAppSelector((state) => state.folders.isLoading);
  const hasFetchedFolders = useAppSelector((state) => state.folders.hasFetched);

  // Get the filter from Redux store
  const filter = filters.find((f: any) => f.id === filterId);

  // Wait for filters and folders to be loaded
  if (isLoadingFilters || !filter || isLoadingFolders || !hasFetchedFolders) {
    return (
      <Container my="md" size="xl">
        <Center h={250}>
          <Loader />
        </Center>
      </Container>
    );
  }

  return (
    <Container my="md" size="xl" mb={300}>
      <Title order={4}>{filter.name}</Title>

      <UserFolders filter={filter} />
    </Container>
  );
};
